export const officialMatchType = {
  matchTypeId: "62259249-902c-4dd7-a46e-b769dcb0cde7",
  name: 'Official Match',
  label: 'offificalMatchLabel',
}

export const practiceMatchType = {
  matchTypeId: "61259249-902c-4dd7-a46e-b769dcb0cde7",
  name: 'Practice Match',
  label: 'practiceMatchLabel'
}

export const matchTypes = {
  "61259249-902c-4dd7-a46e-b769dcb0cde7": {
    name: 'Practice Match',
    label: 'practiceMatchLabel'
  },
  "62259249-902c-4dd7-a46e-b769dcb0cde7": {
    name: 'Official Match',
    label: 'offificalMatchLabel',
  }
}

export const ExportMatchTypes =(matchId,matchNumber)=> {
  if(!matchId) return "";

  if(matchNumber)
  {
    if(matchId === officialMatchType.matchTypeId) return `${officialMatchType.name} ${matchNumber}`; 
  }
  else{
    if(matchId === officialMatchType.matchTypeId) return `${officialMatchType.name}`; 
  }
 

  if(matchId === practiceMatchType.matchTypeId) return practiceMatchType.name;
  // If matchId doesn't match any known type, return null or handle accordingly
  return "";

}

export const officialMatch = {
  matchTypeId: "62259249-902c-4dd7-a46e-b769dcb0cde7",
  name: 'Match',
  label: 'offificalMatchLabel',
}

export const practiceMatch = {
  matchTypeId: "61259249-902c-4dd7-a46e-b769dcb0cde7",
  name: 'Practice',
  label: 'practiceMatchLabel'
}

export const ScheduleMatchTypes =(matchId,matchNumber)=> {
  if(!matchId) return "";

  if(matchNumber)
  {
    if(matchId === officialMatch.matchTypeId) return `${officialMatch.name} ${matchNumber}`; 
  }
  else{
    if(matchId === officialMatch.matchTypeId) return `${officialMatch.name}`; 
  }
 

  if(matchId === practiceMatch.matchTypeId) return practiceMatch.name;
  // If matchId doesn't match any known type, return null or handle accordingly
  return "";

}